import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Skills = () => {
    return (
        <div>
            {/* <h1 className='text-center'>My Skilss</h1>
            <div className='w-100  '>
                <div>
                <p>c++</p>
                <ProgressBar striped variant="success" now={40} />

                </div>
               

            </div> */}
        </div>
    );
};

export default Skills;